(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["focuspod-project-quote"] && !Shopify.designMode) return;
  try {
    (() => {
  function start() {
    const copyNode = document.getElementById('fp-project-copy');
    if (!copyNode || window.FocusPodProjectQuote) return;
    const text = JSON.parse(copyNode.textContent);
    const byId = id => document.getElementById('fp-project-' + id);
    const dialog = byId('dialog');
    const form = byId('quote-form');
    const root = text.root.replace(/\/?$/, '/');
    const pendingKey = 'fp_project_quote_pending_v1';
    const renderedAt = Date.now();
    const uuid = () => window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2);
    const money = cents => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
    const validQuantity = value => /^\d+$/.test(String(value)) && Number(value) >= 1 && Number(value) <= 999;
    let cart = null, busy = false, productBusy = false, productOperation = null, opener = null, dirty = false, receipt = null;
    let pending = null, step = 'review', wantDetails = false, inlineOperation = null, recentSelection = null;
    const recentKey = 'fp_project_recent_selection_v1';
    try { recentSelection = JSON.parse(sessionStorage.getItem(recentKey) || 'null'); } catch (e) {}
    let catalog = {models:[],furniture:[],installation:[],layout_variants:[]};
    try { catalog = JSON.parse(byId('catalog')?.textContent || '{}'); } catch (e) {}
    const models = (catalog.models || []).filter(model => Array.isArray(model.variants) && model.variants.length);
    try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (e) {}
    if (!pending || typeof pending.id !== 'string' || typeof pending.reference !== 'string') pending = null;
    const status = (message, error = false) => {
      byId('status').textContent = message;
      byId('status').dataset.error = String(error);
    };
    const busyState = value => {
      busy = value;
      dialog.setAttribute('aria-busy', String(value));
      byId('fields').disabled = value || !!pending || !!receipt || !cart?.items?.length;
      dialog.querySelectorAll('[data-fp-project-step], [data-fp-project-remove], [data-fp-project-qty]').forEach(el => el.disabled = value || !!receipt || !cart);
      byId('submit').disabled = value || !!pending || !!receipt || !cart?.items?.length;
      byId('continue').disabled = !!pending || !!receipt || !cart?.items?.length;
      byId('step-details').disabled = byId('continue').disabled;
      byId('step-review').disabled = value || !!receipt;
      byId('back').disabled = value;
      byId('reload').disabled = value;
      byId('another').disabled = value;
      byId('picker-fields').disabled = value || !!inlineOperation;
      byId('picker-cancel').disabled = value || !!inlineOperation;
      byId('picker-add').disabled = value || !pickerValid();
      byId('add-model').disabled = value || !!receipt;
      byId('view-cart').disabled = value;
      dialog.querySelector('[data-fp-project-close]').disabled = value;
    };
    function showStep(next, focus = true) {
      step = next; dialog.dataset.step = next;
      for (const name of ['review', 'details', 'receipt']) byId(name).hidden = name !== next;
      byId('continue').hidden = next !== 'review';
      byId('submit').hidden = next !== 'details';
      byId('back').hidden = next !== 'details';
      for (const name of ['review', 'details']) {
        if (name === next) byId('step-' + name).setAttribute('aria-current', 'step');
        else byId('step-' + name).removeAttribute('aria-current');
      }
      byId('title').textContent = next === 'receipt' ? text.receipt_title : text.title;
      dialog.querySelector('.fp-project-body').scrollTop = 0;
      if (focus) (next === 'receipt' ? byId('receipt') : next === 'details' ? byId('name') : byId('title')).focus();
      busyState(busy);
    }
    async function request(path, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(path, { ...options, signal: controller.signal, cache: 'no-store', headers: { Accept: 'application/json', ...(options.headers || {}) } });
        const data = await response.json().catch(() => null);
        if (!response.ok || !data) {
          const error = new Error(data?.description || 'Request failed');
          error.status = response.status;
          throw error;
        }
        return data;
      } finally { clearTimeout(timer); }
    }
    const readCart = async () => {
      const value = await request(root + 'cart.js');
      if (!Array.isArray(value.items) || value.currency !== 'AUD' || !Number.isSafeInteger(value.total_price)) throw new Error('Invalid cart');
      return value;
    };
    const properties = item => Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value !== '' && value !== null);
    const selectionLabel = (value, item) => {
      const id = item.properties?.['_FocusPod configuration'];
      if (!id) return '';
      const ids = Array.from(new Set(value.items.map(line => line.properties?.['_FocusPod configuration']).filter(Boolean)));
      return text.selection + ' ' + (ids.indexOf(id) + 1);
    };
    const fingerprint = value => JSON.stringify([value.currency, value.total_price, value.taxes_included, value.items.map(item => [item.key, item.quantity, item.final_price, item.final_line_price, item.title, item.properties])]);
    function totals(value) {
      const included = value.taxes_included === true;
      const total = value.total_price;
      const gst = Math.round(total * (included ? 1 / 11 : 0.1));
      return { subtotal: included ? total - gst : total, gst, total: included ? total : total + gst };
    }
    const node = (tag, content, className) => {
      const element = document.createElement(tag);
      if (content !== undefined) element.textContent = content;
      if (className) element.className = className;
      return element;
    };
    const isPod = item => /^FocusPod(?:™)?\s+(Solo(?:\s+Plus)?|Duo|Team|Meet|Max)\b/i.test(item.product_title || item.title);
    function renderCart() {
      const list = byId('items'); list.replaceChildren();
      if (!cart.items.length) list.append(node('p', text.empty));
      const groups = new Map();
      cart.items.forEach(item => {
        const key = item.properties?.['_FocusPod configuration'] || 'line:' + item.key;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(item);
      });
      let index = 0;
      groups.forEach(items => {
        const group = node('div', undefined, 'fp-project-group');
        const hasPod = items.some(isPod);
        items.slice().sort((a, b) => Number(isPod(b)) - Number(isPod(a))).forEach(item => {
          const addon = hasPod && !isPod(item);
          const row = node('div', undefined, 'fp-project-item' + (addon ? ' fp-project-addon' : ''));
          const info = node('div', undefined, 'fp-project-item-info');
          const src = item.featured_image?.url || item.image;
          if (!addon && typeof src === 'string' && /^(https:)?\/\//.test(src)) {
            const img = node('img'); img.src = src; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy'; info.append(img);
          }
          const copy = node('div', undefined, 'fp-project-item-copy');
          const title = item.product_title || item.title;
          const configuration = addon && item.properties?.Configuration;
          const displayTitle = configuration || (isPod(item) ? title.match(/^FocusPod(?:™)?\s+(Solo(?:\s+Plus)?|Duo|Team|Meet|Max)\b/i)[0] : /^(FocusPod\s+)?(Assembly|Installation)/i.test(title) ? text.installation : title.replace(/^FocusPod\s+/i, ''));
          copy.append(node('h3', displayTitle));
          const detail = [];
          if (item.variant_title && item.variant_title !== 'Default Title' && !(configuration && item.variant_title.endsWith(configuration))) detail.push(item.variant_title);
          properties(item).forEach(([key, value]) => {
            if (key === 'Pod Model' && (hasPod || title.includes(String(value)))) return;
            if (key === 'Configuration' && configuration) return;
            detail.push(key + ': ' + value);
          });
          if (detail.length) copy.append(node('p', detail.join(' · ')));
          info.append(copy);
          const price = node('div', undefined, 'fp-project-item-price');
          price.append(node('strong', money(item.final_line_price)), node('small', money(item.final_price) + ' ' + text.unit_short));
          const controls = node('div', undefined, 'fp-project-item-bottom');
          const stepper = node('div', undefined, 'fp-project-stepper');
          const input = node('input'); Object.assign(input, { id: 'fp-project-line-' + index++, type: 'number', min: '1', max: '999', step: '1', value: item.quantity, inputMode: 'numeric', required: true });
          input.setAttribute('aria-label', text.item_qty + ' ' + item.title); input.dataset.fpProjectQty = item.key;
          for (const delta of [-1, 1]) {
            const button = node('button', delta < 0 ? '−' : '+'); button.type = 'button';
            button.dataset.fpProjectStep = String(delta); button.dataset.fpProjectKey = item.key;
            button.setAttribute('aria-label', (delta < 0 ? text.decrease : text.increase) + ' ' + item.title);
            if (delta > 0) stepper.append(input);
            stepper.append(button);
          }
          const remove = node('button', '×', 'fp-project-remove'); remove.type = 'button'; remove.dataset.fpProjectRemove = item.key;
          remove.setAttribute('aria-label', text.remove + ' ' + item.title); remove.title = text.remove;
          controls.append(stepper, remove); row.append(info, price, controls); group.append(row);
        });
        list.append(group);
      });
      const sum = totals(cart), area = byId('totals'); area.replaceChildren(); area.className = 'fp-project-totals';
      area.append(node('span', text.estimate, 'fp-project-total-label'), node('strong', money(sum.subtotal), 'fp-project-total-value'), node('span', text.ex_gst, 'fp-project-total-tax'));
      const podCount = cart.items.filter(isPod).reduce((sum, item) => sum + item.quantity, 0);
      const totalCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);
      byId('mini-summary').textContent = podCount ? podCount + ' ' + (podCount === 1 ? text.pod : text.pods) : totalCount + ' ' + (totalCount === 1 ? text.item : text.items);
      byId('volume-note').hidden = podCount < 2;
      const tax = byId('tax-detail'); tax.replaceChildren();
      for (const [label, amount] of [[text.subtotal, sum.subtotal], [text.gst, sum.gst], [text.total, sum.total]]) {
        const p = node('p', undefined, 'fp-project-tax-row'); p.append(node('span', label), node('span', money(amount))); tax.append(p);
      }
      const difference = cart.items.reduce((s, item) => s + item.final_line_price, 0) - cart.total_price;
      if (difference > 0) tax.append(node('p', text.discount_note + ' ' + money(difference)));
      tax.append(node('p', cart.taxes_included ? text.included_note : text.excluded_note));
      busyState(busy);
    }
    async function loadCart() {
      if (busy) return;
      busyState(true); status(text.loading); byId('reload').hidden = true;
      try {
        cart = await readCart(); renderCart();
        status(pending ? text.pending + ' ' + pending.reference : '');
      } catch (e) { cart = null; byId('reload').hidden = false; status(text.cart_load_error, true); }
      finally { busyState(false); }
    }
    async function openQuote(button) {
      opener = button || document.activeElement;
      if (!dialog.open) dialog.showModal();
      if (receipt) { byId('receipt').focus(); return; }
      showStep('review', false);
      await loadCart();
      byId('title').focus();
      dialog.scrollTop = 0;
    }
    async function changeLine(key, quantity) {
      if (busy || receipt || !cart) return false;
      const focused = document.activeElement;
      const focusKey = focused?.dataset.fpProjectQty || focused?.dataset.fpProjectKey || focused?.dataset.fpProjectRemove;
      const focusDelta = focused?.dataset.fpProjectStep;
      let success = false;
      busyState(true); status(text.updating); byId('reload').hidden = true;
      try {
        cart = await request(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        dirty = true; renderCart(); status(''); success = true;
      } catch (e) {
        dirty = true; cart = null; wantDetails = false; byId('reload').hidden = false; status(text.updating_failed, true);
      } finally {
        busyState(false);
        if (success && wantDetails) { wantDetails = false; goDetails(); }
        else if (success && focusKey && (!document.activeElement || document.activeElement === document.body)) {
          const controls = Array.from(dialog.querySelectorAll('[data-fp-project-qty], [data-fp-project-step]'));
          (controls.find(el => (el.dataset.fpProjectQty || el.dataset.fpProjectKey) === focusKey && (focusDelta ? el.dataset.fpProjectStep === focusDelta : !!el.dataset.fpProjectQty)) || byId('title')).focus();
        }
      }
      return success;
    }
    const changedQuantity = () => Array.from(dialog.querySelectorAll('[data-fp-project-qty]')).find(input => !validQuantity(input.value) || Number(input.value) !== cart?.items.find(item => item.key === input.dataset.fpProjectQty)?.quantity);
    async function commitQuantity(input) {
      if (!validQuantity(input.value)) { input.setCustomValidity(text.invalid_quantity); input.reportValidity(); input.focus(); return false; }
      const item = cart?.items.find(item => item.key === input.dataset.fpProjectQty);
      if (!item) return false;
      if (item.quantity === Number(input.value)) return true;
      return changeLine(item.key, Number(input.value));
    }
    async function goDetails() {
      if (busy) { wantDetails = true; return; }
      if (!cart?.items.length || receipt || pending) return;
      if (inlineOperation || (!byId('picker').hidden && byId('model').value)) { status(text.resolve_add, true); byId('picker-add').focus(); return; }
      const input = changedQuantity();
      if (input) {
        if (!validQuantity(input.value)) { await commitQuantity(input); return; }
        wantDetails = true; await commitQuantity(input); return;
      }
      wantDetails = false; status(''); showStep('details');
    }
    byId('continue').addEventListener('click', goDetails);
    byId('step-details').addEventListener('click', goDetails);
    for (const id of ['back', 'step-review']) byId(id).addEventListener('click', () => { if (!busy) { wantDetails = false; showStep('review'); } });
    dialog.addEventListener('click', event => {
      const change = event.target.closest('[data-fp-project-step], [data-fp-project-remove]');
      if (!change || busy || !cart) return;
      if (change.dataset.fpProjectRemove) { changeLine(change.dataset.fpProjectRemove, 0); return; }
      const item = cart.items.find(item => item.key === change.dataset.fpProjectKey);
      if (!item) return;
      const quantity = item.quantity + Number(change.dataset.fpProjectStep);
      if (quantity < 1 || quantity > 999) return;
      changeLine(item.key, quantity);
    });
    dialog.addEventListener('change', event => { if (event.target.matches('[data-fp-project-qty]') && !busy) commitQuantity(event.target); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('[data-fp-project-qty]')) { event.preventDefault(); if (!busy) commitQuantity(event.target); }
    });
    dialog.addEventListener('input', event => event.target.setCustomValidity?.(''));
    dialog.querySelector('[data-fp-project-close]').addEventListener('click', () => { if (!busy) dialog.close(); });
    dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
    dialog.addEventListener('close', () => {
      if (dirty) { const url = new URL(location.href); url.searchParams.delete('fp_quote'); location.assign(url.href); }
      else opener?.focus?.();
    });
    byId('reload').addEventListener('click', loadCart);
    byId('view-cart').addEventListener('click', () => {
      if (busy) return;
      const url = new URL(text.cart_url, location.origin);
      const preview = new URLSearchParams(location.search).get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id', preview);
      location.assign(url.href);
    });
    const selectedModel = () => models.find(model => model.handle === byId('model').value);
    function furnitureChoices(model) {
      if (!model) return [];
      const standard = (catalog.furniture || []).find(variant => variant.title === model.name);
      const variants = [...(catalog.furniture || []), ...(catalog.layout_variants || [])];
      const choices = standard ? [{key:'standard',label:text.standard_package,description:model.standard_description || '',variant:standard}] : [];
      for (const layout of model.layouts || []) {
        const variant = variants.find(item => item.id === layout.variant_id);
        if (variant) choices.push({...layout,variant});
      }
      return choices;
    }
    function fillFurnitureSelect(select, model, includeNone) {
      select.replaceChildren();
      if (includeNone) { const option = node('option', text.no_furniture); option.value = ''; select.append(option); }
      furnitureChoices(model).forEach(choice => {
        const option = node('option', choice.label + ' · ' + money(choice.variant.price) + ' ' + text.unit_short + (choice.variant.available ? '' : ' — ' + text.unavailable));
        option.value = choice.key; option.disabled = !choice.variant.available; select.append(option);
      });
    }
    const chosenFurniture = () => furnitureChoices(selectedModel()).find(choice => choice.key === byId('picker-furniture').value);
    const extraVariant = type => type === 'furniture' ? chosenFurniture()?.variant : (catalog[type] || []).find(variant => variant.title === selectedModel()?.name);
    const selectedVariant = () => selectedModel()?.variants.find(variant => String(variant.id) === byId('variant').value);
    function pickerValid() {
      const variant = selectedVariant();
      return !!variant?.available && validQuantity(byId('picker-qty').value) && (!byId('picker-furniture').value || extraVariant('furniture')?.available) && (!byId('picker-installation').checked || extraVariant('installation')?.available);
    }
    function pickerTotal() {
      let cents = Number(selectedVariant()?.price || 0);
      if (byId('picker-furniture').value) cents += Number(extraVariant('furniture')?.price || 0);
      if (byId('picker-installation').checked) cents += Number(extraVariant('installation')?.price || 0);
      byId('layout-description').textContent = chosenFurniture()?.description || '';
      byId('picker-total').textContent = selectedModel() && validQuantity(byId('picker-qty').value) ? money(cents * Number(byId('picker-qty').value)) + ' ' + (text.taxes_included ? text.included_note : text.ex_gst) : '';
      byId('picker-add').disabled = busy || !pickerValid();
    }
    function populatePicker() {
      const model = selectedModel(); byId('picker-config').hidden = !model;
      byId('variant').replaceChildren(); byId('picker-product').replaceChildren();
      if (model) {
        model.variants.forEach(variant => {
          const option = node('option', variant.title + (variant.available ? '' : ' — ' + text.unavailable)); option.value = variant.id; option.disabled = !variant.available; byId('variant').append(option);
        });
        byId('variant').value = String(model.variants.find(v => v.available)?.id || model.variants[0].id);
        byId('variant-label').hidden = model.variants.length < 2;
        if (model.image) { const img = node('img'); img.src = model.image; img.alt = ''; img.width = 44; img.height = 44; byId('picker-product').append(img); }
        byId('picker-product').append(node('span', 'FocusPod ' + model.name + (model.variants.length === 1 && model.variants[0].title !== 'Default Title' ? ' · ' + model.variants[0].title : '')));
        fillFurnitureSelect(byId('picker-furniture'),model,true);
        const installation = extraVariant('installation'); byId('picker-installation').checked = false; byId('picker-installation').disabled = !installation?.available;
        byId('installation-price').textContent = installation?.available ? '+ ' + money(installation.price) + ' ' + text.unit_short : text.unavailable;
      }
      byId('picker-status').textContent = ''; pickerTotal();
    }
    const placeholder = node('option', text.choose_model); placeholder.value = ''; byId('model').append(placeholder);
    models.forEach(model => { const option = node('option', model.name); option.value = model.handle; option.disabled = !model.variants.some(v => v.available); byId('model').append(option); });
    byId('model').addEventListener('change', populatePicker);
    for (const id of ['variant','picker-qty','picker-furniture','picker-installation']) byId(id).addEventListener('input', event => { event.target.setCustomValidity?.(''); pickerTotal(); });
    byId('add-model').addEventListener('click', () => {
      byId('picker').hidden = false; byId('add-model').setAttribute('aria-expanded', 'true'); byId('model').focus();
      byId('picker').scrollIntoView({block:'nearest',behavior:'smooth'});
    });
    byId('picker-cancel').addEventListener('click', () => {
      if (busy || inlineOperation) return;
      byId('model').value = ''; byId('picker-qty').value = '1'; populatePicker(); byId('picker').hidden = true;
      byId('add-model').setAttribute('aria-expanded', 'false'); byId('add-model').focus(); status('');
    });
    dialog.querySelectorAll('[data-fp-picker-step]').forEach(button => button.addEventListener('click', () => {
      if (busy || inlineOperation) return;
      const input = byId('picker-qty'); input.value = String(Math.max(1, Math.min(999, (Number(input.value) || 1) + Number(button.dataset.fpPickerStep)))); input.setCustomValidity(''); pickerTotal();
    }));
    byId('picker-add').addEventListener('click', async () => {
      if (busy || !pickerValid()) return;
      const model = selectedModel(), quantity = Number(byId('picker-qty').value);
      if (!inlineOperation) {
        const id = uuid(), selected = [{variant:selectedVariant()}];
        if (byId('picker-furniture').value) selected.push({variant:extraVariant('furniture'),configuration:chosenFurniture()?.label});
        if (byId('picker-installation').checked) selected.push({variant:extraVariant('installation')});
        inlineOperation = {id, items:selected.map(({variant,configuration}) => ({id:variant.id,quantity,properties:{'_FocusPod configuration':id,'Pod Model':model.title || 'FocusPod ' + model.name,...(configuration ? {'Configuration':configuration} : {})}}))};
      }
      busyState(true); status(''); byId('picker-status').textContent = text.adding;
      try {
        const existing = await readCart();
        const missing = inlineOperation.items.map(item => ({...item, quantity:Math.max(0,item.quantity - existing.items.filter(line => line.variant_id === item.id && line.properties?.['_FocusPod configuration'] === inlineOperation.id).reduce((sum,line) => sum + line.quantity,0))})).filter(item => item.quantity > 0);
        if (missing.length) await request(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:missing})});
        cart = await readCart(); dirty = true; inlineOperation = null; renderCart();
        byId('model').value = ''; byId('picker-qty').value = '1'; populatePicker(); byId('picker').hidden = true; byId('add-model').setAttribute('aria-expanded', 'false');
        byId('picker-add').textContent = text.add_selection; status(text.picker_success); byId('add-model').focus();
      } catch (error) {
        dirty = true; wantDetails = false;
        if (error.status >= 400 && error.status < 500) { inlineOperation = null; byId('picker-status').textContent = text.cart_error; }
        else { byId('picker-status').textContent = text.picker_error; byId('picker-add').textContent = text.retry_add; }
      } finally { busyState(false); if (wantDetails && !inlineOperation) { wantDetails = false; goDetails(); } }
    });
    function quoteLines(value, customer, reference, timestamp) {
      const sum = totals(value);
      const lines = [text.pdf_heading, text.reference + ': ' + reference, text.request_time + ': ' + timestamp, '', text.name + ': ' + customer.name, text.email + ': ' + customer.email];
      if (customer.company) lines.push(text.company + ': ' + customer.company);
      if (customer.phone) lines.push(text.phone + ': ' + customer.phone);
      lines.push(text.location + ': ' + customer.location, '', value.taxes_included ? text.included_note : text.excluded_note, '');
      value.items.forEach((item, index) => {
        lines.push((index + 1) + '. ' + item.title);
        const group = selectionLabel(value, item); if (group) lines.push('   ' + group);
        properties(item).forEach(([key, val]) => lines.push('   ' + key + ': ' + val));
        lines.push('   ' + text.quantity_label + ': ' + item.quantity + ' | ' + text.unit + ': ' + money(item.final_price) + ' | ' + text.line + ': ' + money(item.final_line_price), '');
      });
      const discount = value.items.reduce((s, item) => s + item.final_line_price, 0) - value.total_price;
      if (discount > 0) lines.push(text.discount_note + ' ' + money(discount));
      lines.push(text.subtotal + ': ' + money(sum.subtotal), text.gst + ': ' + money(sum.gst), text.total + ': ' + money(sum.total), '', text.price_note, text.tax_note);
      if (customer.notes) lines.push('', text.notes + ': ' + customer.notes);
      return lines;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || pending || receipt || step !== 'details' || !cart?.items.length) return;
      if (!form.reportValidity()) return;
      const customer = Object.fromEntries(['name', 'email', 'phone', 'company', 'location', 'notes'].map(key => [key, byId(key).value.trim()]));
      if (!customer.name || !customer.location || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.email)) { status(text.rejected, true); return; }
      const changedInput = changedQuantity();
      if (changedInput) { showStep('review'); status(text.cart_changed, true); changedInput.focus(); return; }
      if (navigator.onLine === false) { status(text.offline, true); return; }
      busyState(true); status(text.sending);
      let sent = false, accepted = false, automation = {outcome:'disabled',key:null};
      try {
        const latest = await readCart();
        if (fingerprint(latest) !== fingerprint(cart)) { cart = latest; renderCart(); showStep('review'); status(text.cart_changed, true); return; }
        let id = uuid(), reference = 'FPQ-' + new Date().toISOString().slice(0, 10).replace(/-/g, '') + '-' + id.slice(0, 8).toUpperCase();
        pending = { id, reference };
        try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch (e) {}
        sent = true;
        if (window.FPProjectQuoteConnector) {
          automation = await window.FPProjectQuoteConnector.prepare(cart, catalog, customer, {
            reference, renderedAt,
            attribution: window.FocusPodTracking?.getAttribution?.() || window.FocusPodTracking?.requestMetadata?.() || {},
            hp: form.querySelector('[name="fp_company_url"]')?.value || '',
            turnstileToken: form.querySelector('[name="cf-turnstile-response"]')?.value || ''
          });
          if (automation.key) id = automation.key;
          if (automation.data?.reference) reference = automation.data.reference;
          accepted = automation.outcome === 'settled';
        }
        const timestamp = new Date().toISOString();
        const lines = quoteLines(cart, customer, reference, timestamp);
        const payload = { ...customer, source: 'Whole-cart quote request', page: location.origin + location.pathname, event_id: id, reference, requested_at: timestamp, currency: cart.currency, item_quantity: cart.items.reduce((s, item) => s + item.quantity, 0), estimated_totals_cents: totals(cart), cart_total_cents: cart.total_price, taxes_included: cart.taxes_included, items: cart.items.map(item => ({ configuration_id: item.properties?.['_FocusPod configuration'] || null, variant_id: item.variant_id, title: item.title, quantity: item.quantity, unit_price_cents: item.final_price, line_total_cents: item.final_line_price, properties: Object.fromEntries(properties(item)) })), message: lines.join('\n'), _subject: 'FocusPod quote request ' + reference };
        Object.assign(payload, window.FocusPodTracking?.requestMetadata?.() || {});
        Object.assign(payload, {event_id:id,reference,quote_automation_status:automation.data?.status || automation.outcome,quote_automation_reason:automation.reason || automation.data?.error || '',quote_submission_key:automation.key || ''});
        pending = { id, reference, connectorKey: automation.key };
        try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch (e) {}
        sent = true;
        const sendNotification = () => request('https://formspree.io/f/xaqzydew', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        try {
          if (window.FPProjectQuoteConnector) await window.FPProjectQuoteConnector.sendNotification(sendNotification, automation);
          else await sendNotification();
        } catch (error) {
          if (!accepted) {
            if (window.FPProjectQuoteConnector?.isUncertain(automation)) error.connectorUncertain = true;
            throw error;
          }
        }
        accepted = true;
        receipt = { id, reference, timestamp, lines };
        pending = null;
        try { sessionStorage.removeItem(pendingKey); } catch (e) {}
        byId('reference').textContent = text.reference + ': ' + reference;
        byId('reload').hidden = true;
        showStep('receipt'); status(text.accepted); form.reset();
        try { window.FocusPodTracking?.track?.('generate_lead', { lead_type: 'cart_quote', form_id: form.id, event_id: id, currency: 'AUD' }, 'cart_quote_' + id); } catch (e) {}
      } catch (e) {
        if (accepted) { status(text.accepted); }
        else if (!sent) status(text.cart_load_error, true);
        else if (e.status >= 400 && e.status < 500 && !e.connectorUncertain) {
          pending = null;
          try { sessionStorage.removeItem(pendingKey); } catch (err) {}
          status(text.rejected, true);
        } else status(text.unconfirmed + ' ' + (pending?.reference || ''), true);
      } finally { busyState(false); }
    });
    byId('another').addEventListener('click', () => {
      if (busy) return;
      receipt = null; showStep('review'); byId('reload').hidden = true;
      loadCart();
    });
    function makePdf(lines) {
      const canvas = document.createElement('canvas'); canvas.width = 1240; canvas.height = 1754;
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Canvas unavailable');
      context.font = '24px Arial';
      const wrapped = [];
      lines.forEach(line => String(line).split('\n').forEach(paragraph => {
        let current = '';
        paragraph.split(/\s+/).forEach(word => {
          if (current && context.measureText(current + ' ' + word).width > 1100) { wrapped.push(current); current = ''; }
          if (context.measureText(word).width > 1100) {
            for (const char of Array.from(word)) {
              if (context.measureText(current + char).width > 1100) { wrapped.push(current); current = ''; }
              current += char;
            }
          } else current += (current ? ' ' : '') + word;
        });
        wrapped.push(current);
      }));
      const pages = [];
      for (let offset = 0; offset < wrapped.length; offset += 46) {
        context.fillStyle = '#ffffff'; context.fillRect(0, 0, 1240, 1754); context.fillStyle = '#142338'; context.font = '24px Arial';
        wrapped.slice(offset, offset + 46).forEach((line, index) => {
          context.font = offset === 0 && index === 0 ? 'bold 26px Arial' : '24px Arial';
          context.fillText(line, 70, 85 + index * 34);
        });
        context.fillText('FocusPod | ' + (pages.length + 1), 70, 1680);
        pages.push(Uint8Array.from(atob(canvas.toDataURL('image/jpeg', 0.92).split(',')[1]), char => char.charCodeAt(0)));
      }
      const encode = value => new TextEncoder().encode(value);
      const parts = [], offsets = [0]; let length = 0;
      const append = value => { const part = typeof value === 'string' ? encode(value) : value; parts.push(part); length += part.length; };
      const object = (id, content, binary) => { offsets[id] = length; append(id + ' 0 obj\n' + content); if (binary) { append('\nstream\n'); append(binary); append('\nendstream'); } append('\nendobj\n'); };
      append('%PDF-1.4\n');
      object(1, '<< /Type /Catalog /Pages 2 0 R >>');
      object(2, '<< /Type /Pages /Count ' + pages.length + ' /Kids [' + pages.map((_, i) => (3 + i * 3) + ' 0 R').join(' ') + '] >>');
      pages.forEach((jpeg, index) => {
        const id = 3 + index * 3;
        object(id, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /XObject << /Im0 ' + (id + 1) + ' 0 R >> >> /Contents ' + (id + 2) + ' 0 R >>');
        object(id + 1, '<< /Type /XObject /Subtype /Image /Width 1240 /Height 1754 /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpeg.length + ' >>', jpeg);
        const command = encode('q 595 0 0 842 0 0 cm /Im0 Do Q');
        object(id + 2, '<< /Length ' + command.length + ' >>', command);
      });
      const xref = length;
      append('xref\n0 ' + offsets.length + '\n0000000000 65535 f \n');
      offsets.slice(1).forEach(offset => append(String(offset).padStart(10, '0') + ' 00000 n \n'));
      append('trailer\n<< /Size ' + offsets.length + ' /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF');
      return new Blob(parts, { type: 'application/pdf' });
    }
    byId('download').addEventListener('click', () => {
      if (!receipt) return;
      try {
        const url = URL.createObjectURL(makePdf(receipt.lines)); const link = node('a');
        link.href = url; link.download = receipt.reference + '.pdf'; document.body.append(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (e) { status(text.pdf_error, true); }
    });
    function productTotal() {
      const quantity = byId('quantity'); const prices = document.querySelector('.fpx__price-block');
      if (!quantity || !prices) return;
      const cents = Number(prices.dataset.basePrice) + (document.getElementById('fpx-furn-check')?.checked ? Number(prices.dataset.furnCents) : 0) + (document.getElementById('fpx-install-check')?.checked ? Number(prices.dataset.installCents) : 0);
      byId('selection-total').textContent = validQuantity(quantity.value) ? text.selection_total + ': ' + money(cents * Number(quantity.value)) : text.invalid_quantity;
      const unitPrice = document.getElementById('fpx-total-price'); if (unitPrice) unitPrice.textContent = money(cents);
      const stickyPrice = document.getElementById('fpx-sticky-price');
      if (stickyPrice && validQuantity(quantity.value)) { stickyPrice.replaceChildren(document.createTextNode(money(cents * Number(quantity.value)) + ' '), node('small', text.ex_gst)); }
    }
    function setupProductFurniture() {
      const container = document.querySelector('[data-fp-product-handle]'), checkbox = document.getElementById('fpx-furn-check');
      const model = models.find(item => item.handle === container?.dataset.fpProductHandle);
      if (!model || !checkbox || !furnitureChoices(model).length) return;
      const box = node('div', undefined, 'fp-project-layout-choice');
      const label = node('label', text.furniture_layout); label.htmlFor = 'fp-project-product-furniture';
      const select = node('select'); select.id = 'fp-project-product-furniture'; fillFurnitureSelect(select,model,false);
      const description = node('p'); description.id = 'fp-project-product-layout-description'; select.setAttribute('aria-describedby', description.id);
      box.append(label,select,description); checkbox.closest('label')?.after(box);
      const sync = () => {
        const choice = furnitureChoices(model).find(item => item.key === select.value);
        box.hidden = !checkbox.checked; description.textContent = choice?.description || text.layout_help;
        if (choice) {
          checkbox.dataset.variantId = choice.variant.id; checkbox.dataset.fpConfiguration = choice.label;
          const priceBlock = document.querySelector('.fpx__price-block'); if (priceBlock) priceBlock.dataset.furnCents = choice.variant.price;
          const row = checkbox.closest('label'), priceLabel = row?.querySelector('.fpx__addon-price'), descLabel = row?.querySelector('.fpx__addon-desc'), photo = row?.querySelector('.fpx__addon-photo');
          if (priceLabel) priceLabel.textContent = '+ ' + money(choice.variant.price) + ' ex GST';
          if (descLabel) descLabel.textContent = choice.description || model.standard_description || text.standard_package;
          if (photo) photo.hidden = choice.key !== 'standard';
        }
        productTotal();
      };
      select.addEventListener('change',sync);
      document.addEventListener('change',event => { if (['fpx-furn-check','fpx-install-check'].includes(event.target.id)) sync(); });
      sync();
    }
    const extrasDialog = byId('extras-dialog');
    ['cancel','review','continue'].forEach(action => byId('extras-' + action)?.addEventListener('click', () => {
      if (extrasDialog?.open) extrasDialog.close(action);
    }));
    function confirmProductExtras(quantity, title) {
      const furniture = document.getElementById('fpx-furn-check');
      const installation = document.getElementById('fpx-install-check');
      const missingFurniture = furniture && !furniture.checked;
      const missingInstallation = installation && !installation.checked;
      if (!missingFurniture && !missingInstallation) return Promise.resolve(null);
      byId('extras-furniture').hidden = !missingFurniture;
      byId('extras-installation').hidden = !missingInstallation;
      byId('extras-selection').textContent = title + ' · ' + quantity + ' ' + (quantity === 1 ? text.pod : text.pods);
      byId('extras-continue').textContent = missingFurniture && missingInstallation ? text.extras_continue_both : missingFurniture ? text.extras_continue_furniture : text.extras_continue_installation;
      extrasDialog.returnValue = 'cancel';
      return new Promise(resolve => {
        extrasDialog.addEventListener('close', () => resolve({ action: extrasDialog.returnValue, target: missingFurniture ? furniture : installation }), { once: true });
        extrasDialog.showModal();
        byId('extras-title').focus();
      });
    }
    async function addProduct(forQuote) {
      if (productBusy) return;
      productTotal();
      const quantity = byId('quantity');
      if (!validQuantity(quantity?.value)) { quantity?.setCustomValidity(text.invalid_quantity); quantity?.reportValidity(); return; }
      const selected = [{ id: Number(document.querySelector('#fpx-form [name=id]').value || document.querySelector('[data-fp-product-variant]')?.dataset.fpProductVariant), quantity: Number(quantity.value) }];
      ['fpx-furn-check', 'fpx-install-check'].forEach(id => { const box = document.getElementById(id); if (box?.checked) selected.push({ id: Number(box.dataset.variantId), quantity: Number(quantity.value), ...(box.dataset.fpConfiguration ? {configuration:box.dataset.fpConfiguration} : {}) }); });
      if (selected.some(item => !Number.isSafeInteger(item.id) || item.id <= 0)) { byId('product-status').textContent = text.cart_error; return; }
      const signature = JSON.stringify(selected);
      if (productOperation && productOperation.signature !== signature) { byId('product-status').textContent = text.cart_error; return; }
      const title = document.querySelector('main h1')?.textContent.trim() || document.title;
      productBusy = true;
      const controls = [...['fpx-atc-btn', 'fpx-sticky-btn', 'fpx-quote-btn', 'fpx-furn-check', 'fpx-install-check', 'fp-project-quantity','fp-project-product-furniture'].map(id => document.getElementById(id)).filter(Boolean), ...document.querySelectorAll('[data-fp-product-step]')];
      const disabled = controls.map(el => el.disabled); controls.forEach(el => el.disabled = true);
      let extrasDecision = null;
      try {
        byId('product-status').textContent = '';
        if (forQuote) {
          extrasDecision = await confirmProductExtras(Number(quantity.value), title);
          if (extrasDecision && extrasDecision.action !== 'continue') return;
        }
        byId('product-status').textContent = text.adding;
        const existing = await readCart();
        if (forQuote && recentSelection?.signature === signature && existing.items.some(line => line.variant_id === selected[0].id && line.properties?.['_FocusPod configuration'] === recentSelection.id)) {
          byId('product-status').textContent = ''; await openQuote(document.getElementById('fpx-quote-btn')); return;
        }
        if (!productOperation) productOperation = { signature, id: uuid() };
        selected.forEach(item => { item.properties = { '_FocusPod configuration': productOperation.id, 'Pod Model': title, ...(item.configuration ? {'Configuration':item.configuration} : {}) }; delete item.configuration; });
        const missing = selected.map(item => ({ ...item, quantity: Math.max(0, item.quantity - existing.items.filter(line => line.variant_id === item.id && line.properties?.['_FocusPod configuration'] === productOperation.id).reduce((sum, line) => sum + line.quantity, 0)) })).filter(item => item.quantity > 0);
        if (missing.length) await request(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: missing }) });
        recentSelection = {signature,id:productOperation.id}; try { sessionStorage.setItem(recentKey,JSON.stringify(recentSelection)); } catch (e) {}
        productOperation = null; byId('product-status').textContent = text.added;
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (forQuote) {
          await openQuote(document.getElementById('fpx-quote-btn'));
        }
      } catch (e) { byId('product-status').textContent = text.cart_error; }
      finally {
        productBusy = false; controls.forEach((el, index) => el.disabled = disabled[index]);
        if (extrasDecision?.action === 'review') {
          const target = extrasDecision.target.closest('label') || extrasDecision.target;
          target.setAttribute('tabindex', '-1'); target.scrollIntoView({ block: 'center', behavior: 'smooth' }); target.focus({ preventScroll: true });
        } else if (extrasDecision && extrasDecision.action !== 'continue') document.getElementById('fpx-quote-btn')?.focus();
      }
    }
    window.FocusPodProjectQuote = { addProduct, openQuote };
    document.getElementById('fpx-form')?.addEventListener('submit', event => { event.preventDefault(); addProduct(false); });
    ['fp-project-quantity', 'fpx-furn-check', 'fpx-install-check'].forEach(id => document.getElementById(id)?.addEventListener('input', event => { event.target.setCustomValidity?.(''); productTotal(); }));
    document.querySelectorAll('[data-fp-product-step]').forEach(button => button.addEventListener('click', () => {
      if (productBusy) return;
      const input = byId('quantity');
      const value = (validQuantity(input.value) ? Number(input.value) : 1) + Number(button.dataset.fpProductStep);
      input.value = String(Math.max(1, Math.min(999, value))); input.setCustomValidity(''); productTotal();
    }));
    setupProductFurniture(); productTotal();
    function addCartButton() {
      const checkout = document.querySelector('#main-cart-footer #checkout, #checkout');
      if (!checkout || document.querySelector('[data-fp-project-open]')) return;
      const button = node('button', text.cart_action, 'fp-project-cart-button'); button.type = 'button'; button.dataset.fpProjectOpen = 'true';
      checkout.closest('.cart__ctas')?.before(button);
    }
    document.addEventListener('click', event => { const button = event.target.closest?.('[data-fp-project-open]'); if (button) { event.preventDefault(); openQuote(button); } });
    addCartButton();
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter?.parentElement) new MutationObserver(addCartButton).observe(cartFooter.parentElement, { childList: true, subtree: true });
    if (new URLSearchParams(location.search).get('fp_quote') === '1' && location.pathname.replace(/\/$/, '') === text.cart_url.replace(/\/$/, '')) openQuote();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fp-product-film"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-fp-product-film]').forEach(section => {
    if (section.dataset.filmReady) return;
    const video = section.querySelector('video');
    const preview = section.querySelector('[data-fp-film-start]');
    if (!video || !preview) return;
    section.dataset.filmReady = 'true';
    const showPreview = () => {
      const returnFocus = document.activeElement === video;
      video.pause();
      video.hidden = true;
      preview.hidden = false;
      if (returnFocus) preview.focus({ preventScroll: true });
    };
    preview.addEventListener('click', async event => {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      preview.hidden = true;
      video.hidden = false;
      video.focus({ preventScroll: true });
      try { await video.play(); } catch (_) { showPreview(); }
    });
    video.addEventListener('play', () => { preview.hidden = true; });
    video.addEventListener('ended', showPreview);
    video.addEventListener('error', showPreview);
    window.addEventListener('pagehide', () => video.pause());
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting && !video.paused) video.pause();
      }, { threshold: 0.05 });
      observer.observe(section);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
